import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { QuestionTypeEnum } from "../../../../Constants";
import { Row, Form, Col, Button } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import {
  InputControl,
  InputValidationConstants,
  createOptionsFromEnum,
  SelectControl,
  CheckboxControl,
} from "wup-module1-base";
import { useState } from "react";
import QuestionModal from "./QuestionModal";

function RelatedQuestions({
  fields,
  register,
  errors,
  move,
  remove,
  append,
  update,
  getValues,
}) {
  const [isEdit, setIsEdit] = useState(null);
  const [relatedQuestion, setRelatedQuestion] = useState(null);

  const handleDrop = (droppedQuestion) => {
    if (!droppedQuestion.destination) return;
    if (droppedQuestion.destination.droppableId === "container")
      move(droppedQuestion.source.index, droppedQuestion.destination.index);
    else remove(droppedQuestion.source.index);
  };

  const handleEditButtonClick = (question, idx) => {
    setIsEdit(true);
    const data = getValues();
    const copiedQuestion = { ...question };
    copiedQuestion.content2 = copiedQuestion.content;
    delete copiedQuestion.content;
    copiedQuestion.type = data.relatedQuestions[idx].type;
    copiedQuestion.name = data.relatedQuestions[idx].name;
    setRelatedQuestion(copiedQuestion);
  };

  const handleAddButtonClick = () => {
    setIsEdit(false);
    const length = fields.length;
    const question = {
      id: uuidv4(),
      name: null,
      type: null,
      description: null,
      content2: null,
      order: length + 1,
      answer: {},
    };
    setRelatedQuestion(question);
  };

  return (
    <>
      <p className="fw-700 mb-2">Pytania skorelowane</p>
      <Card className={"droppable-card"}>
        {fields.length > 0 && (
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="container">
              {(provided) => (
                <Card.Body {...provided.droppableProps} ref={provided.innerRef}>
                  {fields.map((question, index) => (
                    <Draggable
                      key={question.id}
                      draggableId={question.id}
                      index={index}
                    >
                      {(provided) => (
                        <Row
                          className="droppable-row py-2 px-4 m-2 no-select"
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <Col>
                            <InputControl
                              id={`relatedQuestions.${index}.name`}
                              label={"Nazwa"}
                              readOnly={false}
                              errors={errors}
                              refs={{
                                ...register(`relatedQuestions.${index}.name`, {
                                  required: InputValidationConstants.required,
                                }),
                              }}
                            />
                          </Col>
                          <Col md={4}>
                            <SelectControl
                              id={`relatedQuestions.${index}.type`}
                              label={"Typ"}
                              errors={errors}
                              options={createOptionsFromEnum(
                                QuestionTypeEnum,
                                false
                              )}
                              readOnly={false}
                              refs={{
                                ...register(`relatedQuestions.${index}.type`, {
                                  required: InputValidationConstants.required,
                                }),
                              }}
                            />
                          </Col>
                          <Col
                            md={"auto"}
                            className="d-flex"
                            style={{ alignItems: "center" }}
                          >
                            <Button
                              variant="secondary"
                              style={{ marginTop: "0.88rem" }}
                              //className="mt-3 ml-2"
                              onClick={() =>
                                handleEditButtonClick(question, index)
                              }
                            >
                              <FontAwesomeIcon className="mr-2" icon={faEdit} />
                              Edytuj
                            </Button>
                          </Col>
                          {/* <input
                            id={`relatedQuestions.${index}.id`}
                            type={"hidden"}
                          />
                          <input
                            id={`relatedQuestions.${index}.description`}
                            type={"hidden"}
                          />
                          <input
                            id={`relatedQuestions.${index}.value`}
                            type={"hidden"}
                          /> */}
                        </Row>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Card.Body>
              )}
            </Droppable>
            <Droppable droppableId="trash-bin">
              {(provided) => (
                <Card.Body
                  className="border-danger border droppable-trash-can rounded mx-5 my-3 pb-4"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <Row className="justify-content-center align-items-center">
                    <Col md={"auto"} className="text-center text-danger ">
                      <FontAwesomeIcon icon={faTrashCan} size="2x" />
                      <span className="mx-2 text-monospace font-weight-bold">
                        Przeciągnij, aby usunąć
                      </span>
                    </Col>
                  </Row>
                  {provided.placeholder}
                </Card.Body>
              )}
            </Droppable>
          </DragDropContext>
        )}
        <Row className="justify-content-center align-items-center pb-3">
          <Col md={"auto"}>
            <Button
              className="px-3"
              type="button"
              variant="primary"
              onClick={() => handleAddButtonClick()}
            >
              Dodaj pytanie
            </Button>
          </Col>
        </Row>
      </Card>
      <QuestionModal
        isEdit={isEdit}
        question={relatedQuestion}
        setQuestion={setRelatedQuestion}
        appendQuestion={append}
        updateQuestion={update}
        questionFields={fields}
      />
    </>
  );
}

export default RelatedQuestions;
